import { render, staticRenderFns } from "./EditProfilePage.vue?vue&type=template&id=7fcb0798"
import script from "./EditProfilePage.vue?vue&type=script&lang=js"
export * from "./EditProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports